var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Component 30 \\u2013 1",
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Search results for Email - Flaticon-3"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8505"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8504"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 7438",
  d: "M21.891 4H2.109A2.113 2.113 0 0 0 0 6.109v12.657a2.113 2.113 0 0 0 2.109 2.109h19.782A2.112 2.112 0 0 0 24 18.766V6.109A2.111 2.111 0 0 0 21.891 4Zm-.3 1.406-8.1 8.061a2.109 2.109 0 0 1-2.984 0l-8.1-8.06ZM1.406 18.479V6.4l6.077 6.045Zm1 .989 6.074-6.035 1.034 1.029a3.516 3.516 0 0 0 4.971 0l1.035-1.03 6.074 6.036Zm20.188-.989-6.077-6.038L22.594 6.4Z",
  fill: "#191919"
}))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 4597",
  fill: "none",
  d: "M0 0h24v24H0z"
})));
export default SvgMail;